<template>
  <div :class="{ cover: !$store.getters.ambientType }">
    <van-search
      class="order-search"
      placeholder="搜索订单"
      v-model.trim="likeParam"
      @search="onSearch"
      autofocus
    />
    <div
      class="searchHistory"
      v-if="historyList.length && showHistory"
    >
      <div class="shTittle">
        <span>历史搜索</span>
        <i
          class="iconfont icon-qingchusousuojieguo"
          @click="delHistory"
        ></i>
      </div>
      <div class="history">
        <span
          v-for="(item,index) in historyList"
          :key="index"
          @click="historySearch(index)"
        >{{item}}</span>
      </div>
    </div>
    <van-list
      class="order-content"
      v-model="isUpLoading"
      :finished="finished"
      :finished-text="!orderList.length ? '' : '没有更多了'"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="onReachBottom"
      v-if="!showHistory"
    >
      <div
        class="order-box"
        v-for="(item, index) in orderList"
        :key="index"
        @click="goToOrderDetails(item.orderId)"
      >
        <div class="order-head van-hairline--bottom">
          <div class="shop-img">
            <img
              :src="imgPrex + item.sellerImageLogo"
              alt
            />
          </div>
          <div class="shop-title">
            <div class="shop-name">
              <span class="van-ellipsis">{{ item.sellerName }}</span>
            </div>
            <div class="shop-time">{{ item.createTime }}</div>
          </div>
          <div
            class="order-state"
            :style="{ color: item.orderState == 5 || item.orderState == 6 ? '#1D1D1D' : '#FF1310' }"
          >
            {{ item.orderState == "3"? "待发货" : item.orderState == "4"? "已发货" : item.orderState == "5"? "已完成" : item.orderState == "6"? "交易关闭": ""}}
          </div>
        </div>
        <div
          class="goods-box"
          v-for="(goods, goodsIndex) in item.ordersProduct"
          :key="goodsIndex"
        >
          <div class="goods-img">
            <img
              :src="imgPrex + goods.imageUrl"
              alt
            />
            <span v-if="goods.refundState == 1">退款中</span>
            <span v-if="goods.refundState == 3">已退款</span>
          </div>
          <div class="goods-content">
            <div class="goods-name van-multi-ellipsis--l2">
              <span
                style="background: linear-gradient(90deg,#78e71e 0%,#15ad26 100%);"
                v-if="goods.type == 5 || goods.type == 6 || goods.type == 7"
              >同城</span>
              <span
                style="background: linear-gradient(90deg,#fb6a4a 0%,#ff0808 100%,#ff0808 100%);"
                v-if="goods.type == 3 || goods.type == 6"
              >秒杀</span>
              <span
                style="background: linear-gradient(90deg,#4da0ff 0%,#336df7 100%);"
                v-if="goods.type == 4 || goods.type == 7"
              >拼单</span>
              <span
                style="background: linear-gradient(90deg,#f2b05b 0%,#ff7617 100%);"
                v-if="goods.isRecommend == 1"
              >推荐</span>
              <b>{{ goods.productName }}</b>
            </div>
            <div class="goods-money flex-between">
              <div style="font-size: 0">
                <span class="goods-price">¥{{ goods.totalMoneyPrice }}</span><span
                  class="goods-disPrice"
                  v-show="goods.totalSellerSalePrice"
                >¥{{ goods.totalSellerSalePrice }}</span>
              </div>
              <div
                class="goods-brokerage"
                v-if="goods.brokerage != 0 && flag != 2"
              >
                利润:¥{{ goods.brokerage }}
              </div>
            </div>
            <div class="goods-num">x{{ goods.count | integer }}</div>
          </div>
        </div>
        <div class="goods-total van-hairline--bottom">
          实付金额:<span>¥{{ item.moneyOrder }}</span>
        </div>
        <div class="goods-buyer flex-between">
          <div
            class="flex-between"
            @click.stop
          >
            <img
              src="../../assets/img/order_send.png"
              alt
              @click="dialPhone(item.buyerMobile)"
            />
            <span
              class="van-ellipsis"
              style="color: #a4a4a4"
            >买家: {{ item.buyerName }}</span>
          </div>
          <div v-if="flag != 2">
            预估收益:<span style="color: #ff120f; font-weight: 800">¥{{ item.communityShopIncome }}</span>
          </div>
        </div>
        <div
          class="goods-remind"
          v-if="item.orderState == 3 || item.orderState == 4"
        >
          <van-button
            type="default"
            text="提醒商家发货"
            class="goods-btn seller-btn"
            v-if="item.orderState == 3"
            @click.stop="tips(item.orderId)"
          />
          <van-button
            type="default"
            text="确认提货"
            class="goods-btn pick-btn"
            v-if="item.orderState == 4"
            @click.stop="submit(item.orderId, index)"
          />
          <van-button
            class="goods-btn"
            text="提醒用户取货"
            v-if="item.orderState == 4"
            @click.stop="pushPickUpUrge(item.orderId)"
          />
        </div>
      </div>
      <div
        class="notHave"
        v-show="!orderList.length && !isUpLoading && !error"
      >
        <i class="iconfont icon-personal_image_nosto1"></i>
        <p>暂时没有订单哦</p>
      </div>
    </van-list>
  </div>
</template>

<script>
import { orders, pushPickUpUrge, confirmReceipt, csPushDelivery } from "@/api/join";
export default {
  data() {
    return {
      orderList: [],
      isUpLoading: false, // 上拉加载状态（true处于加载状态）
      finished: true, // 数据全部加载状态（true为数据全部加载完毕,不再请求数据接口）
      pageIndex: 1, // 分页页数
      error: false, // 是否加载失败状态（true为加载失败）
      flag: this.$route.query.flag || 1, //标识 0普通用户 ,1社区店店长 ,2社区店副店长
      likeParam: "",//查询条件
      historyList: [],
      showHistory: true
    }
  },
  filters: {
    integer(val) {
      return parseInt(val);
    },
  },
  methods: {
    historySearch(index) {
      this.likeParam = this.historyList[index];
      this.dataProcessing();
      if (index > 0) {
        this.historyList.unshift(this.historyList.splice(index, 1)[0]);
        this.historyList.slice(0, 10);
        localStorage.setItem("orderSearchHistory", JSON.stringify(this.historyList));
      }
    },
    delHistory() {
      this.$dialog
        .alert({
          message: "是否确定删除？",
          confirmButtonText: "确定",
          confirmButtonColor: "#1993FF",
          cancelButtonText: "取消",
          cancelButtonColor: "#1D1D1D",
          showCancelButton: true,
        })
        .then(() => {
          this.historyList = [];
          localStorage.removeItem("orderSearchHistory");
        });
    },
    onSearch() {
      if (this.likeParam == "") return false;
      this.dataProcessing();
      let index = this.historyList.indexOf(this.likeParam);
      index == -1 ? this.historyList.unshift(this.likeParam) : this.historyList.unshift(this.historyList.splice(index, 1)[0]);
      this.historyList.slice(0, 10);
      localStorage.setItem("orderSearchHistory", JSON.stringify(this.historyList));
    },
    dataProcessing() {
      this.showHistory = false;
      // 清空列表数据
      this.pageIndex = 1;
      this.error = false;
      this.finished = false;
      this.orderList = [];
      // 重新加载数据
      // 将 isUpLoading 设置为 true，表示处于加载状态
      this.isUpLoading = true;
      this.orders();
    },
    goToOrderSearch() {
      this.$router.push("/orderSearch");
    },
    submit(id, index) {
      this.$dialog
        .alert({
          message: "用户已收到商品并确认提货？",
          confirmButtonText: "确定",
          confirmButtonColor: "#1993FF",
          cancelButtonText: "取消",
          cancelButtonColor: "#1D1D1D",
          showCancelButton: true,
        })
        .then(() => {
          confirmReceipt(
            `ordersId=${id}&token=${this.$store.getters.token}`
          ).then((res) => {
            if (res.appStatus.errorCode == 0) {
              this.orderList[index].orderState = 5;
              this.$store.commit("user/SET_modifyOrderState", true);
            }
          });
        });
    },
    dialPhone(phone) {
      if (this.$store.getters.ambientType != 1) {
        window.location.href = "tel:" + phone;
      } else {
        window.Android.dialPhone(phone);
      }
    },
    goToOrderDetails(id) {
      this.$router.push({
        path: "/orderDetails",
        query: { orderId: id },
      });
    },
    pushPickUpUrge(id) {
      pushPickUpUrge({ orderId: id }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$toast("提醒成功");
        }
      });
    },
    onReachBottom() {
      this.orders();
    },
    orders() {
      orders({
        page: {
          way: "1", // 0:不分页 后台最多返回999条数据 1:分页
          index: this.pageIndex, // 请求页数，index = 1 表示第一页
          size: "10", //数量
        },
        orderType: "0", //订单列表类型 0全部， 1待发货， 2已发货（待提货）， 3已完成， 4已关闭
        likeParam: this.likeParam,//查询条件
      })
        .then((res) => {
          if (res.appStatus.errorCode == 0) {
            const list = res.content.orderList;
            if (list.length < 10) {
              // 最后一页不足10条的情况
              this.finished = true;
            }
            // 处理数据
            if (this.pageIndex === 1) {
              this.orderList = list;
            } else {
              this.orderList = this.orderList.concat(list);
            }
            this.pageIndex++;
          } else {
            this.error = true;
          }
          this.isUpLoading = false;
        })
        .catch((res) => {
          this.error = true;
          this.isUpLoading = false;
        });
    },
    // 提醒发货
    tips(orderId) {
      csPushDelivery({ orderId }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$toast("提醒商家发货成功～");
        }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/orderDetails") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      this.likeParam = "";
      this.showHistory = true;
    }
    this.historyList = JSON.parse(localStorage.getItem("orderSearchHistory")) || [];
  }
}
</script>

<style lang="scss" scoped>
.cover {
  .order-search {
    top: 0;
  }
  .notHave {
    min-height: calc(100vh - 40px);
  }
}
.order-search {
  position: fixed;
  top: 44px;
  left: 0;
  right: 0;
  height: 40px;
  padding: 4px 15px;
  z-index: 666;
  .van-search__content {
    border-radius: 16px;
  }
}
.searchHistory {
  padding-top: 40px;
  padding-left: 15px;
  .shTittle {
    width: 345px;
    height: 50px;
    padding-right: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    span {
      font-weight: 800;
    }
    i {
      font-size: 25px;
      color: #cbcbcb;
    }
  }
  .history {
    padding-right: 7px;
    span {
      display: inline-block;
      margin-right: 8px;
      margin-bottom: 8px;
      padding: 6px 12px;
      font-size: 12px;
      background-color: #ffffff;
      border-radius: 15px;
    }
  }
}
.order-content {
  padding-top: 40px;
  .order-box {
    margin: 10px 10px 0;
    padding: 4px 5px;
    background-color: #ffffff;
    border-radius: 10px;
    .order-head {
      height: 40px;
      line-height: 20px;
      padding: 5px 0;
      display: flex;
      .shop-img {
        flex: 0 0 40px;
        height: 40px;
        border-radius: 5px;
        overflow: hidden;
        margin-right: 8px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .shop-title {
        flex: 1;
        overflow: hidden;
        .shop-name {
          flex: 1;
          span {
            max-width: 210px;
            font-size: 16px;
            font-weight: 800;
            display: inline-block;
            position: relative;
          }
        }
        .shop-time {
          font-size: 12px;
          color: #8d8d8d;
        }
      }
      .order-state {
        flex-shrink: 0;
        font-size: 16px;
      }
    }
    .goods-box {
      padding-top: 10px;
      display: flex;
      .goods-img {
        width: 90px;
        height: 90px;
        margin-right: 5px;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-radius: 5px;
        }
        span {
          width: 100%;
          height: 20px;
          line-height: 20px;
          position: absolute;
          left: 0;
          bottom: 0;
          font-size: 10px;
          font-weight: 800;
          color: #ffffff;
          text-align: center;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 100;
        }
      }
      .goods-content {
        flex: 1;
        position: relative;
        .goods-name {
          font-size: 15px;
          word-break: break-all;
          span {
            margin-right: 4px;
            padding: 0 1px;
            font-size: 11px;
            color: #ffffff;
            border-radius: 1px;
            vertical-align: middle;
          }
          b {
            font-weight: 400;
            vertical-align: middle;
          }
        }
        .goods-money {
          margin-top: 7px;
          .goods-brokerage {
            font-size: 15px;
          }
        }
        .goods-price {
          font-size: 15px;
          margin-right: 4px;
        }
        .goods-disPrice {
          font-size: 12px;
          font-weight: 500;
          color: #a4a4a4;
          text-decoration: line-through;
        }
        .goods-num {
          font-size: 12px;
          color: #a4a4a4;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
    .goods-total {
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      color: #a4a4a4;
      text-align: right;
      span {
        color: #1d1d1d;
        font-weight: 800;
      }
    }
    .goods-buyer {
      padding: 0 5px;
      height: 50px;
      font-size: 15px;
      img {
        width: 31px;
        height: 31px;
        display: block;
      }
      span {
        width: 150px;
      }
    }
    .goods-remind {
      height: 32px;
      margin-top: -7px;
      padding-bottom: 12px;
      display: flex;
      justify-content: flex-end;
      .goods-btn {
        width: 100px;
        height: 32px;
        padding: 0;
        color: #ffffff;
        background: linear-gradient(90deg, #fb6a4a 0%, #ff0808 100%);
        border-radius: 5px;
      }
      .seller-btn {
        background: linear-gradient(91deg, #5ec3e7 0%, #0083f6 100%);
      }
      .pick-btn {
        width: 78px;
        margin-right: 10px;
        background: linear-gradient(91deg, #5ec3e7 0%, #0083f6 100%);
      }
    }
  }
  .notHave {
    width: 100%;
    height: calc(100vh - 84px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i {
      font-size: 107px;
      color: #d5d5d7;
    }
    p {
      font-size: 15px;
      color: #a3a2a2;
      margin-top: 32px;
    }
  }
}
</style>